<h1 mat-dialog-title>Renvoi du versement au demandeur pour complétion</h1>
<form (ngSubmit)="onSubmit()" [formGroup]="dialogForm" style="margin-top: 20px">
  <mat-dialog-content class="mat__typography">
    <div fxLayout="column" fxLayoutGap="15px">
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(95% - 5px)">
          <mat-label>Indiquer le motif du renvoi</mat-label>
          <textarea matInput formControlName="message" data-cy="textarea-incomplete-message"></textarea>
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button (click)="onNoClick()" color="primary" data-cy="btn-incomplete-cancel">Annuler</button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            type="submit"
            [disabled]="!dialogForm.valid" data-cy="btn-incomplete-send">Envoyer
    </button>
  </div>
</form>
